var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card card-chat-booking float-left ml-3" },
    [
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("b", [_vm._v(_vm._s(_vm.message.text))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userPlace.place_name,
                expression: "userPlace.place_name"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "form-control",
            class: { "form-alert": _vm.errors.has("name") },
            attrs: { name: "name", type: "text", placeholder: "ชื่อที่พัก" },
            domProps: { value: _vm.userPlace.place_name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userPlace, "place_name", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("name"),
                  expression: "errors.has('name')"
                }
              ],
              staticClass: "text-remark pt-1 text-danger"
            },
            [_vm._v(_vm._s(_vm.$t("message.required_field")))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userPlace.place_size_id,
                  expression: "userPlace.place_size_id"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "form-control",
              class: { "form-alert": _vm.errors.has("place_size_id") },
              attrs: { name: "place_size_id" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.userPlace,
                    "place_size_id",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v("กรุณาเลือกประเภทที่พัก")
              ]),
              _vm._v(" "),
              _vm._l(_vm.sortedPlaceSizes, function(placeSize, index) {
                return _c(
                  "option",
                  { domProps: { value: _vm.sortedPlaceSizes[index].id } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("multiLangName")(placeSize)) +
                        "\n        "
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("place_size_id"),
                  expression: "errors.has('place_size_id')"
                }
              ],
              staticClass: "text-remark pt-1 text-danger"
            },
            [_vm._v(_vm._s(_vm.$t("message.required_selection")))]
          )
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userPlace.address,
                expression: "userPlace.address"
              }
            ],
            staticClass: "form-control",
            class: { "form-alert": _vm.errors.has("address") },
            attrs: {
              name: "address",
              rows: "2",
              placeholder: _vm.$t("message.my_listings.location_placeholder")
            },
            domProps: { value: _vm.userPlace.address },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userPlace, "address", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("address"),
                  expression: "errors.has('address')"
                }
              ],
              staticClass: "text-remark pt-1 text-danger"
            },
            [_vm._v(_vm._s(_vm.$t("message.required_field")))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userPlace.address_province_id,
                  expression: "userPlace.address_province_id"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "form-control",
              class: { "form-alert": _vm.errors.has("province_id") },
              attrs: { name: "province_id" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.userPlace,
                    "address_province_id",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v(
                  _vm._s(_vm.$t("message.booking.contact_step.set_province"))
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.sortedProvinces, function(addressProvince, index) {
                return _c(
                  "option",
                  { domProps: { value: addressProvince.id } },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("multiLangName")(addressProvince)) +
                        "\n        "
                    )
                  ]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("province_id"),
                  expression: "errors.has('province_id')"
                }
              ],
              staticClass: "text-remark pt-1 text-danger"
            },
            [_vm._v(_vm._s(_vm.$t("message.required_selection")))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userPlace.district_id,
                  expression: "userPlace.district_id"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "form-control",
              class: { "form-alert": _vm.errors.has("district_id") },
              attrs: { name: "district_id" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.userPlace,
                    "district_id",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                }
              }
            },
            [
              _c("option", { domProps: { value: null } }, [
                _vm._v(
                  _vm._s(_vm.$t("message.booking.contact_step.set_district"))
                )
              ]),
              _vm._v(" "),
              _vm._l(_vm.sortedDistricts, function(district, index) {
                return _c("option", { domProps: { value: district.id } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("multiLangName")(district)) +
                      "\n        "
                  )
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("district_id"),
                  expression: "errors.has('district_id')"
                }
              ],
              staticClass: "text-remark pt-1 text-danger"
            },
            [_vm._v(_vm._s(_vm.$t("message.required_selection")))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userPlace.remark,
                expression: "userPlace.remark"
              }
            ],
            staticClass: "form-control",
            attrs: {
              id: "remark",
              placeholder: _vm.$t("message.my_listings.remark_placeholder"),
              rows: "2"
            },
            domProps: { value: _vm.userPlace.remark },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userPlace, "remark", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "py-3" },
          [
            _c("pet-selection-label"),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center align-items-center pt-2"
              },
              [
                _c("div", { staticClass: "flex-fill" }, [
                  _c("label", [
                    _c("i", { staticClass: "fas fa-paw" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("message.booking.contact_step.pet_remark")
                        )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("toggle-button", {
                      attrs: { sync: true, color: "#8BC34A" },
                      on: { change: _vm.onChangeHasPet },
                      model: {
                        value: _vm.switchHasPet,
                        callback: function($$v) {
                          _vm.switchHasPet = $$v
                        },
                        expression: "switchHasPet"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _vm.selectedPetTypes
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center flex-wrap"
                  },
                  _vm._l(_vm.selectedPetTypes, function(petType) {
                    return _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-start align-items-center border border-chip-gray rounded-pill px-2 py-1 mr-2 mb-2"
                        },
                        [
                          petType.image_url
                            ? _c("div", { staticClass: "pr-2" }, [
                                _c("img", {
                                  attrs: { src: petType.image_url, width: "24" }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm._f("multiLangName")(petType)) + " "
                            ),
                            petType.remark
                              ? _c("span", [
                                  _vm._v(":" + _vm._s(petType.remark))
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    ])
                  }),
                  0
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("message.booking.contact_step.location")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card my-0",
              class: [
                _vm.errors.has("location") ? "border-danger" : "border-divider"
              ]
            },
            [
              _c("div", { staticClass: "card-body p-2" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center"
                  },
                  [
                    _c("div", { staticClass: "flex-fill" }, [
                      _vm.userPlace.latitude && _vm.userPlace.longitude
                        ? _c("span", [
                            _c("i", {
                              staticClass:
                                "fal fa-check-circle text-success fa-lg"
                            }),
                            _vm._v(
                              "  " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.pinned_location"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        : _c("span", [
                            _c("i", {
                              staticClass:
                                "fal fa-exclamation-circle text-danger fa-lg"
                            }),
                            _vm._v(
                              "  " +
                                _vm._s(
                                  _vm.$t(
                                    "message.booking.contact_step.unpinned_location"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-info",
                          on: {
                            click: function($event) {
                              return _vm.openPinlocationModal()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.userPlace.latitude &&
                                  _vm.userPlace.longitude
                                  ? _vm.$t("message.button.edit")
                                  : _vm.$t("message.button.add")
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.errors.has("location")
            ? _c("div", { staticClass: "text-remark -status-alert mt-1" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.required_field")) +
                    "\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        !_vm.saveSuccess
          ? _c("div", { staticClass: "form-group mt-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-block btn-info",
                  attrs: { disabled: _vm.loading },
                  on: { click: _vm.submit }
                },
                [_vm._v("ยืนยัน")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-block btn btn-outline-secondary",
                  on: { click: _vm.cancel }
                },
                [_vm._v("ยกเลิก")]
              )
            ])
          : _c("div", { staticClass: "text-center mt-4" }, [_vm._m(0)])
      ]),
      _vm._v(" "),
      _c("pin-location-modal", {
        ref: "pinLocationModal",
        attrs: { settings: _vm.settings },
        on: { savedLocation: _vm.setLocation }
      }),
      _vm._v(" "),
      _c("pet-type-modal", {
        ref: "petTypeModal",
        on: { onUpdateResult: _vm.updateUserPlacePetTypes }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("i", { staticClass: "fas fa-check-circle -status-accepted" }),
      _vm._v(" บันทึกข้อมูลสำเร็จ\n      ")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dbe8b54", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dbe8b54","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/UserPlaceMessage.vue
// module id = 2261
// module chunks = 0